<template>
  <div :class="$vuetify.breakpoint.mdAndUp ? 'footer desktop' : 'footer mobile'">
    <div class="footer-container">
      <div class="footer-title">MAYACREW</div>
      <div class="footer-subtitle">글로벌 인플루언서 마케팅의 새로운 기준</div>
    </div>
    <div class="copyright">© 2025 MAYACREW. All rights reserved.</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 32px 16px;
  background-color: #111827;
}

.footer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-title {
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px; /* 120% */
}

.footer-subtitle {
  color: #9ca3af;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px; /* 166.667% */
}

.copyright {
  color: #9ca3af;
  text-align: center;
  font-size: 10px;
  font-weight: 400;
  line-height: 18px; /* 180% */
}
</style>
